export type DriversInvalidRecordReason = 'invalid-id' | 'invalid-name';

export class DriversInvalidRecord {
  constructor(
    public driverId: string,
    public reason: DriversInvalidRecordReason,
    public data: Record<string, unknown>
  ) {}
}
